"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareWithdrawal = exports.prepareStakeDeRegistrationCertificate = exports.prepareStakeDelegationCertificate = exports.prepareStakeRegistrationCertificate = exports.prepareLedgerOutput = exports.prepareLedgerInput = void 0;
const ledgerjs_hw_app_cardano_1 = require("@cardano-foundation/ledgerjs-hw-app-cardano");
const utils_1 = require("@cardano-foundation/ledgerjs-hw-app-cardano/dist/utils");
const typhonjs_1 = require("@stricahq/typhonjs");
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const ledgerjs_hw_app_cardano_2 = require("@cardano-foundation/ledgerjs-hw-app-cardano");
const logic_1 = require("./logic");
/**
 * returns the formatted transactionInput for ledger cardano app
 *
 * @param {TyphonTypes.Input} input
 * @param {number} accountIndex
 * @returns {TxInput}
 */
function prepareLedgerInput(input, accountIndex) {
    const paymentKeyPath = input.address.paymentCredential.type === typhonjs_1.types.HashType.ADDRESS
        ? input.address.paymentCredential.bipPath
        : undefined;
    return {
        txHashHex: input.txId,
        outputIndex: input.index,
        path: paymentKeyPath
            ? (0, utils_1.str_to_path)((0, logic_1.getBipPathString)({
                account: accountIndex,
                chain: paymentKeyPath.chain,
                index: paymentKeyPath.index,
            }))
            : null,
    };
}
exports.prepareLedgerInput = prepareLedgerInput;
/**
 * returns the formatted transactionOutput for ledger cardano app
 *
 * @param output
 * @param accountIndex
 * @returns {TxOutput}
 */
function prepareLedgerOutput(output, accountIndex) {
    const isByronAddress = output.address instanceof typhonjs_1.address.ByronAddress;
    let isDeviceOwnedAddress = false;
    let destination;
    if (!isByronAddress) {
        const address = output.address;
        isDeviceOwnedAddress =
            address.paymentCredential &&
                address.paymentCredential.type === typhonjs_1.types.HashType.ADDRESS &&
                address.paymentCredential.bipPath !== undefined;
    }
    if (isDeviceOwnedAddress) {
        const address = output.address;
        const paymentKeyPath = address.paymentCredential
            .bipPath;
        const stakingKeyPath = address.stakeCredential
            .bipPath;
        const paymentKeyPathString = (0, logic_1.getBipPathString)({
            account: accountIndex,
            chain: paymentKeyPath.chain,
            index: paymentKeyPath.index,
        });
        const stakingKeyPathString = (0, logic_1.getBipPathString)({
            account: accountIndex,
            chain: stakingKeyPath.chain,
            index: stakingKeyPath.index,
        });
        destination = {
            type: ledgerjs_hw_app_cardano_2.TxOutputDestinationType.DEVICE_OWNED,
            params: {
                type: ledgerjs_hw_app_cardano_2.AddressType.BASE_PAYMENT_KEY_STAKE_KEY,
                params: {
                    spendingPath: (0, utils_1.str_to_path)(paymentKeyPathString),
                    stakingPath: (0, utils_1.str_to_path)(stakingKeyPathString),
                },
            },
        };
    }
    else {
        const address = output.address;
        destination = {
            type: ledgerjs_hw_app_cardano_2.TxOutputDestinationType.THIRD_PARTY,
            params: {
                addressHex: address.getHex(),
            },
        };
    }
    const tokenBundle = Object.values((0, groupBy_1.default)(output.tokens, ({ policyId }) => policyId)).map(tokens => ({
        policyIdHex: tokens[0].policyId,
        tokens: tokens.map(token => ({
            assetNameHex: token.assetName,
            amount: token.amount.toString(),
        })),
    }));
    return {
        amount: output.amount.toString(),
        destination,
        tokenBundle,
    };
}
exports.prepareLedgerOutput = prepareLedgerOutput;
function prepareStakeRegistrationCertificate(certificate) {
    if (certificate.stakeCredential.type === typhonjs_1.types.HashType.ADDRESS &&
        certificate.stakeCredential.bipPath) {
        return {
            type: ledgerjs_hw_app_cardano_1.CertificateType.STAKE_REGISTRATION,
            params: {
                stakeCredential: {
                    type: ledgerjs_hw_app_cardano_1.StakeCredentialParamsType.KEY_PATH,
                    keyPath: (0, utils_1.str_to_path)((0, logic_1.getBipPathString)({
                        account: certificate.stakeCredential.bipPath.account,
                        chain: certificate.stakeCredential.bipPath.chain,
                        index: certificate.stakeCredential.bipPath.index,
                    })),
                },
            },
        };
    }
    else {
        throw new Error("Invalid stakeKey type");
    }
}
exports.prepareStakeRegistrationCertificate = prepareStakeRegistrationCertificate;
function prepareStakeDelegationCertificate(certificate) {
    if (certificate.stakeCredential.type === typhonjs_1.types.HashType.ADDRESS &&
        certificate.stakeCredential.bipPath) {
        return {
            type: ledgerjs_hw_app_cardano_1.CertificateType.STAKE_DELEGATION,
            params: {
                stakeCredential: {
                    type: ledgerjs_hw_app_cardano_1.StakeCredentialParamsType.KEY_PATH,
                    keyPath: (0, utils_1.str_to_path)((0, logic_1.getBipPathString)({
                        account: certificate.stakeCredential.bipPath.account,
                        chain: certificate.stakeCredential.bipPath.chain,
                        index: certificate.stakeCredential.bipPath.index,
                    })),
                },
                poolKeyHashHex: certificate.poolHash,
            },
        };
    }
    else {
        throw new Error("Invalid stakeKey type");
    }
}
exports.prepareStakeDelegationCertificate = prepareStakeDelegationCertificate;
function prepareStakeDeRegistrationCertificate(certificate) {
    if (certificate.stakeCredential.type === typhonjs_1.types.HashType.ADDRESS &&
        certificate.stakeCredential.bipPath) {
        return {
            type: ledgerjs_hw_app_cardano_1.CertificateType.STAKE_DEREGISTRATION,
            params: {
                stakeCredential: {
                    type: ledgerjs_hw_app_cardano_1.StakeCredentialParamsType.KEY_PATH,
                    keyPath: (0, utils_1.str_to_path)((0, logic_1.getBipPathString)({
                        account: certificate.stakeCredential.bipPath.account,
                        chain: certificate.stakeCredential.bipPath.chain,
                        index: certificate.stakeCredential.bipPath.index,
                    })),
                },
            },
        };
    }
    else {
        throw new Error("Invalid stakeKey type");
    }
}
exports.prepareStakeDeRegistrationCertificate = prepareStakeDeRegistrationCertificate;
function prepareWithdrawal(withdrawal) {
    if (withdrawal.rewardAccount.stakeCredential.type === typhonjs_1.types.HashType.ADDRESS &&
        withdrawal.rewardAccount.stakeCredential.bipPath) {
        return {
            stakeCredential: {
                type: ledgerjs_hw_app_cardano_1.StakeCredentialParamsType.KEY_PATH,
                keyPath: (0, utils_1.str_to_path)((0, logic_1.getBipPathString)({
                    account: withdrawal.rewardAccount.stakeCredential.bipPath.account,
                    chain: withdrawal.rewardAccount.stakeCredential.bipPath.chain,
                    index: withdrawal.rewardAccount.stakeCredential.bipPath.index,
                })),
            },
            amount: withdrawal.amount.toString(),
        };
    }
    else {
        throw new Error("Invalid stakeKey type");
    }
}
exports.prepareWithdrawal = prepareWithdrawal;
//# sourceMappingURL=tx-helpers.js.map